import React, { useEffect, useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { openOAuthPopup } from "../../../../utils/oauthPopup";
import { getAuthorizeUrl } from "../../../../config/oauth";
import { toast } from "react-toastify";

const SocialProfiles = ({socialProfiles, setSocialProfiles, socialloading, setSocialLoading}) => {
    
    const [error, setError] = useState(null);
    const [connecting, setConnecting] = useState(false);

    useEffect(() => {
        try {
            // If socialProfiles is a string, parse it
            if (typeof socialProfiles === 'string') {
                const parsedProfiles = JSON.parse(socialProfiles);
                setSocialProfiles(parsedProfiles);
            }
            setSocialLoading(false);
        } catch (err) {
            console.error('Error parsing social profiles:', err);
            setError('Invalid social profiles data format');
        }
    }, [socialProfiles, setSocialProfiles]);

    const handleInputChange = (field, value) => {
        setSocialProfiles(prevProfiles => ({
            ...prevProfiles,
            [field]: value
        }));
    };

    const handleConnectFacebook = async () => {
        setConnecting(true);
        try {
            const authorizeUrl = await getAuthorizeUrl("facebook");
            const result = await openOAuthPopup(authorizeUrl, { name: "FacebookLogin" });
            
            if (result.code) {
                // In a real app, you'd send this code to your backend to exchange for a token
                // For now, we'll just indicate connection and save the code/state as a placeholder
                handleInputChange('facebook_connected', true);
                handleInputChange('facebook_code', result.code);
                toast.success("Successfully connected to Facebook!");
            }
        } catch (err) {
            console.error("Facebook Connection Error:", err);
            toast.error(err.message || "Failed to connect Facebook.");
        } finally {
            setConnecting(false);
        }
    };

    if (socialloading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const redirectUri = `${window.location.origin}/oauth-callback`;

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-yourdetails dc-tabsinfo">
                <div className="dc-tabscontenttitle">
                    <h3>Social profiles</h3>
                </div>

                <div className="alert alert-info mb-4" style={{ borderRadius: '10px', fontSize: '13px' }}>
                    <i className="fas fa-info-circle mr-2"></i>
                    <strong>Developer Tip:</strong> For Facebook login to work, use this Redirect URI in your Facebook App settings: 
                    <code style={{ background: '#e2e8f0', padding: '2px 6px', borderRadius: '4px', marginLeft: '8px', color: '#2d3748' }}>{redirectUri}</code>
                </div>

                <div className="dc-formtheme dc-userform social-profiles-wrap">
                    <fieldset>
                        <div className="form-group form-group-half dc-inputwithicon wt-facebook">
                            <i className="dc-icon fab fa-facebook" style={{ color: "#3b5998", fontSize: "20px" }}></i>
                            <div className="d-flex gap-2 w-100">
                                <input 
                                    type="text" 
                                    name="basics[facebook]" 
                                    className="form-control" 
                                    value={socialProfiles?.facebook || ""}
                                    onChange={(e) => handleInputChange('facebook', e.target.value)}
                                    placeholder="Facebook Link" 
                                    style={{ flex: 1 }}
                                />
                                <button 
                                    type="button" 
                                    className="btn btn-primary"
                                    onClick={handleConnectFacebook}
                                    disabled={connecting}
                                    style={{ 
                                        whiteSpace: 'nowrap', 
                                        borderRadius: '8px',
                                        background: '#3b5998',
                                        borderColor: '#3b5998',
                                        fontSize: '12px',
                                        fontWeight: 600
                                    }}
                                >
                                    {connecting ? 'Connecting...' : socialProfiles?.facebook_connected ? 'Connected' : 'Connect Login'}
                                </button>
                            </div>
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-twitter">
                            <i className="dc-icon fab fa-twitter" style={{ color: "#55acee", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[twitter]" 
                                className="form-control" 
                                value={socialProfiles?.twitter || ""}
                                onChange={(e) => handleInputChange('twitter', e.target.value)}
                                placeholder="Twitter Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-linkedin">
                            <i className="dc-icon fab fa-linkedin" style={{ color: "#0177b5", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[linkedin]" 
                                className="form-control" 
                                value={socialProfiles?.linkedin || ""}
                                onChange={(e) => handleInputChange('linkedin', e.target.value)}
                                placeholder="Linkedin Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-skype">
                            <i className="dc-icon fab fa-skype" style={{ color: "#00aff0", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[skype]" 
                                className="form-control" 
                                value={socialProfiles?.skype || ""}
                                onChange={(e) => handleInputChange('skype', e.target.value)}
                                placeholder="Skype ID" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-pinterestp">
                            <i className="dc-icon fab fa-pinterest-p" style={{ color: "#bd081c", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[pinterest]" 
                                className="form-control" 
                                value={socialProfiles?.pinterest || ""}
                                onChange={(e) => handleInputChange('pinterest', e.target.value)}
                                placeholder="Pinterest Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-tumblr">
                            <i className="dc-icon fab fa-tumblr" style={{ color: "#36465d", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[tumblr]" 
                                className="form-control" 
                                value={socialProfiles?.tumblr || ""}
                                onChange={(e) => handleInputChange('tumblr', e.target.value)}
                                placeholder="Tumblr Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-instagram">
                            <i className="dc-icon fab fa-instagram" style={{ color: "#c53081", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[instagram]" 
                                className="form-control" 
                                value={socialProfiles?.instagram || ""}
                                onChange={(e) => handleInputChange('instagram', e.target.value)}
                                placeholder="Instagram Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-flickr">
                            <i className="dc-icon fab fa-flickr" style={{ color: "#ff0084", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[flickr]" 
                                className="form-control" 
                                value={socialProfiles?.flickr || ""}
                                onChange={(e) => handleInputChange('flickr', e.target.value)}
                                placeholder="Flickr Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-medium">
                            <i className="dc-icon fab fa-medium" style={{ color: "#02b875", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[medium]" 
                                className="form-control" 
                                value={socialProfiles?.medium || ""}
                                onChange={(e) => handleInputChange('medium', e.target.value)}
                                placeholder="Medium Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-tripadvisor">
                            <i className="dc-icon fab fa-tripadvisor" style={{ color: "#FF0000", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[tripadvisor]" 
                                className="form-control" 
                                value={socialProfiles?.tripadvisor || ""}
                                onChange={(e) => handleInputChange('tripadvisor', e.target.value)}
                                placeholder="Tripadvisor Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-wikipedia">
                            <i className="dc-icon fab fa-wikipedia-w" style={{ color: "#5a5b5c", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[wikipedia]" 
                                className="form-control" 
                                value={socialProfiles?.wikipedia || ""}
                                onChange={(e) => handleInputChange('wikipedia', e.target.value)}
                                placeholder="Wikipedia Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-vimeo">
                            <i className="dc-icon fab fa-vimeo-square" style={{ color: "#00adef", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[vimeo]" 
                                className="form-control" 
                                value={socialProfiles?.vimeo || ""}
                                onChange={(e) => handleInputChange('vimeo', e.target.value)}
                                placeholder="Vimeo Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-youtube">
                            <i className="dc-icon fab fa-youtube" style={{ color: "#cd201f", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[youtube]" 
                                className="form-control" 
                                value={socialProfiles?.youtube || ""}
                                onChange={(e) => handleInputChange('youtube', e.target.value)}
                                placeholder="Youtube Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-whatsapp">
                            <i className="dc-icon fab fa-whatsapp" style={{ color: "#0dc143", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[whatsapp]" 
                                className="form-control" 
                                value={socialProfiles?.whatsapp || ""}
                                onChange={(e) => handleInputChange('whatsapp', e.target.value)}
                                placeholder="Whatsapp Number" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-vkontakte">
                            <i className="dc-icon fab fa-vk" style={{ color: "#5A80A7", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[vkontakte]" 
                                className="form-control" 
                                value={socialProfiles?.vkontakte || ""}
                                onChange={(e) => handleInputChange('vkontakte', e.target.value)}
                                placeholder="Vkontakte Link" 
                            />
                        </div>
                        <div className="form-group form-group-half  dc-inputwithicon wt-odnoklassniki">
                            <i className="dc-icon fab fa-odnoklassniki" style={{ color: "#f58220", fontSize: "20px" }}></i>
                            <input 
                                type="text" 
                                name="basics[odnoklassniki]" 
                                className="form-control" 
                                value={socialProfiles?.odnoklassniki || ""}
                                onChange={(e) => handleInputChange('odnoklassniki', e.target.value)}
                                placeholder="Odnoklassniki Link" 
                            />
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    );
};

export default SocialProfiles;
